import { ICategory } from '../categories/category';
import { ICurrency, IStandardItem } from '../structure';

export interface IArticle extends IStandardItem {
  articleID: number;
  name: string;
  priority: number;
  description?: string;
  amount: number;
  info: string;
  info2: string;
  quantity: number;
  totalPrice: number;
  member: {
    iD: string;
    displayName: string;
  };
  categories: ICategory[];
  tags: unknown[];
  month?: string;
  cache: unknown;
  validFrom?: string;
  validTo?: string;
  currency: ICurrency;
  priceOld?: number;
}

export interface IArticleGroup {
  articleGroupID: number;
  availableForClickAndCollectDeliverTime: boolean;
  availableForClickAndCollectText: boolean;
  availableForRadiusDeliveryDeliverTime: boolean;
  availableForRadiusDeliveryText: boolean;
  availableForShippingDeliverTime: boolean;
  availableForShippingText: boolean;
  baseStock: boolean;
  freePrice: boolean;
  minimumAge: boolean;
  name: string;
  number: string;
  parent: boolean;
  properties: [];
  propertiesEx: IPropertiesEx[];
  type: ArticleGroupType;
}

export interface IPropertiesEx {
  article: boolean;
  articleGroupPropertyID: number;
  articleKey: boolean;
  masterSlave: boolean;
  nullable: boolean;
  property: { ID: number };
  range: boolean;
  required: boolean;
}

export enum ArticleGroupType {
  Plant = 0,
  Product = 1,
  Voucher = 2,
  Ticket = 3,
  Cemetery = 4,
  Picture = 5,
  Video = 6,
  RollLawn = 7,
  Winterings = 8,
  Service = 9,
  Shipping = 10,
  Subscription = 11,
  Archive = 12
}
